import browserType from '../../../../../shared/utils/browserType'

const areaKey = 'flow_bg'
type AreaKeyState = 'visible' | 'hidden'

const toggleBackgroundStyle = (state: AreaKeyState) => {
  if (state === 'visible') {
    showBackground()
  } else {
    hideBackground()
  }
}

export const getAreaBackgroundState = () => {
  if (localStorage) {
    return localStorage.getItem(areaKey) as AreaKeyState | null
  }

  return null
}

export const setAreaState = (state: AreaKeyState) => {
  if (localStorage) {
    localStorage.setItem(areaKey, state)
  }

  toggleBackgroundStyle(state)
}

export const initArea = () => {
  const currentState = getAreaBackgroundState()

  if (!currentState) {
    if (browserType() === 'Firefox') {
      setAreaState('hidden')
    } else {
      setAreaState('visible')
    }
  } else {
    toggleBackgroundStyle(currentState)
  }
}

const showBackground = () => {
  const bg = document.querySelector('.rete-background')

  if (bg) {
    (bg as HTMLDivElement).style.display = 'table'
  }
}

const hideBackground = () => {
  const bg = document.querySelector('.rete-background')

  if (bg) {
    (bg as HTMLDivElement).style.display = 'none'
  }
}
